import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  obtenerDirectiva,
  setListadoDirectiva,
  setMessageError,
} from "../../sliceRedux/ValidarReserva.slice";
import { useSelector } from "react-redux";
import RenderToast from "../../componentes/RenderToast";
import { Fieldset } from "primereact/fieldset";
import moment from "moment";
import Observation from "../../componentes/Observation";

const RevisarDirectivaConstitucion = (props) => {
  const { showLoader, hideLoader, dispatch, toast, codSolConstitucion, codGrupoConstAdec } = props;
  const [bandejaDirectiva, setBandejaDirectiva] = useState([]);
  const listadoDirectiva = useSelector((state) => state.validar.listadoDirectiva);
  const messageError = useSelector((state) => state.validar.messageError);
  const [expandedRows, setExpandedRows] = useState([]);

  useEffect(() => {
    showLoader();
    dispatch(obtenerDirectiva(codSolConstitucion, codGrupoConstAdec));
  }, []);

  useEffect(() => {
    if (listadoDirectiva.code === 200) {
      let listado = listadoDirectiva?.object?.listCargoDirectiva ?? [];
      listado = [...listado].sort((a, b) =>
        b.nemCatTipoGobierno.localeCompare(b.nemCatTipoGobierno)
      );
      setBandejaDirectiva(listado);
    }

    return () => {
      hideLoader();
      dispatch(setListadoDirectiva({ ...listadoDirectiva, ...{ code: 0 } }));
    };
  }, [listadoDirectiva.code]);

  useEffect(() => {
    if (messageError != "") {
      RenderToast(toast, "error", "Error", messageError);
      hideLoader();
    }
    return () => {
      dispatch(setMessageError(""));
    };
  }, [messageError]);

  const headerTemplate = (data) => {
    return <span className="font-bold">{data.nomCatTipoGobierno}</span>;
  };

  const footerTemplate = (data) => {
    return <></>;
  };
  return (
    <>
      <div className="card">
        <Observation observationValue={listadoDirectiva?.object?.observacion} />
        <Fieldset toggleable legend="Datos del representante legal" className="mb-4">
          <div className="grid">
            <div className="flex col-12 md:col-3 ">
              <span className="mr-2" style={{ minWidth: "130px", textAlign: "left" }}>
                Tipo de identificación:
              </span>
              <div className="font-medium">{listadoDirectiva?.object?.tipoIdentificacion}</div>
            </div>

            <div className="col-12 md:col-9 ">
              <span className="mr-4">Apellidos y nombres:</span>
              <span className="font-medium">{listadoDirectiva?.object?.nombre}</span>
            </div>
            <div className="flex col-12 md:col-3 ">
              <span
                htmlFor="identificacion"
                className="mr-2"
                style={{ minWidth: "130px", textAlign: "left" }}
              >
                Identificación:
              </span>
              <div className="font-medium">{listadoDirectiva?.object?.numIdentificacion}</div>
            </div>
            <div className="flex col-12 md:col-6 ">
              <span
                htmlFor="identificacion"
                className="mr-2"
                style={{ minWidth: "130px", textAlign: "left" }}
              >
                Fecha de nombramiento:
              </span>
              <div className="font-medium">
                {listadoDirectiva?.object?.fecNombramiento
                  ? moment(listadoDirectiva?.object?.fecNombramiento).format("DD/MM/YYYY")
                  : ""}
              </div>
            </div>
          </div>
        </Fieldset>

        <DataTable
          className="p-datatable-responsive-demo"
          paginator
          rows={25}
          dataKey="codParamCargoGrupSoc"
          loading={undefined}
          value={bandejaDirectiva}
          rowGroupMode="subheader"
          groupRowsBy="nemCatTipoGobierno"
          expandableRowGroups
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          rowGroupHeaderTemplate={headerTemplate}
          rowGroupFooterTemplate={footerTemplate}
          emptyMessage="Sin registros que mostrar."
          columnResizeMode="fit"
          style={{ width: "100%", overflow: "auto!important" }}
        >
          <Column field="nomCatCargo" header="Gobierno" headerStyle={{ textAlign: "center" }} />
          <Column
            field="obligatorio"
            header="Obligatorio"
            headerStyle={{ textAlign: "center" }}
            body={(rowData) => (rowData.obligatorio ? "Sí" : "No")}
          />
          <Column
            field="numIdentificacion"
            header="Identificación"
            headerStyle={{ textAlign: "center" }}
          />
          <Column
            field="nombres"
            header="Apellidos y nombres"
            headerStyle={{ textAlign: "center" }}
          />
          <Column
            field="nomCatCargoDirectv"
            header="Directivo"
            headerStyle={{ textAlign: "center" }}
          />
        </DataTable>
      </div>
    </>
  );
};
export default RevisarDirectivaConstitucion;
